module.exports = __webpack_public_path__ + "img/emblem_two@2x.7fe1e23b.png";